export const STORAGE_KEYS = {
  FCM_TOKEN: "fcm_token",
  DRAFT_PLACE: "draft_place",
  MAP_CENTER: "map_center",
  USER_INTERESTS: "user_interests",
  HAS_SEEN_ACCESSIBILITY_POPUP: "hasSeenAccessibilityPopup",
  CONTRIBUTE_PLACE: "contribute_place",
  UPDATE_REASON: "update_reason",
  PROFILE_TAB: "profileTab",
  AUTH_TOKEN: "token",
  USER_DATA: "user_data",
  FROM_EXPLORE_TO_CONTRIBUTE: "from_explore_to_contribute",
};

export const storage = {
  setItem: (key: string, value: string) => {
    try {
      localStorage.setItem(key, value);
    } catch (e) {
      console.error("Error saving to localStorage", e);
    }
  },
  getItem: (key: string) => {
    try {
      return localStorage.getItem(key);
    } catch (e) {
      console.error("Error reading from localStorage", e);
      return null;
    }
  },
  removeItem: (key: string) => {
    try {
      localStorage.removeItem(key);
    } catch (e) {
      console.error("Error removing from localStorage", e);
    }
  },
};

export const session = {
  setItem: (key: string, value: string) => {
    try {
      sessionStorage.setItem(key, value);
    } catch (e) {
      console.error("Error saving to sessionStorage", e);
    }
  },
  getItem: (key: string) => {
    try {
      return sessionStorage.getItem(key);
    } catch (e) {
      console.error("Error reading from sessionStorage", e);
      return null;
    }
  },
  removeItem: (key: string) => {
    try {
      sessionStorage.removeItem(key);
    } catch (e) {
      console.error("Error removing from sessionStorage", e);
    }
  },
};
